import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './nav-button.css';

const Navigation = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const navItems = [
    { label: 'Test Reports', path: 'dashboard/TestReports' },
    { label: 'Products', path: 'dashboard/Products' },
    { label: 'Factories', path: 'dashboard/Factories' },
    { label: 'Product Certification', path: 'dashboard/ProductCertification' },
    { label: 'Certification Management', path: 'dashboard/CertificationManagement' },
    { label: 'Test Labs', path: 'dashboard/TestLabs' },
    { label: 'Ask Rexi', path: 'dashboard/AskRexi' },
  ];

  return (
    <nav className="main-navigation">
      <div className="nav-bar">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }: { isActive: boolean }) =>
              `nav-button ${isActive ? 'active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}

        {/* ✅ Final working logout button with no type friction */}
        <NavLink
          to="/"
          className="nav-button outline"
          onClick={async (e: any) => {
            e.preventDefault();
            await logout();
            navigate('/');
          }}
        >
          Logout
        </NavLink>
      </div>
    </nav>
  );
};

export default Navigation;
